import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';
import { IVacanciesFilter } from 'src/pages/vacancies/vacancies.interfaces';

export const GET_VACANCIES = gql`
  query getVacancies(
    $workspaceCompanyId: ObjectId!
    $queryOptions: QueryOptionsInput!
    $filters: FilterVacanciesInput!
  ) {
    getVacancies(
      workspaceCompanyId: $workspaceCompanyId
      queryOptions: $queryOptions
      filters: $filters
    ) {
      collection {
        _id
        createdBy
        status
        createdAt
        job {
          title
        }
        company {
          name
        }
        jobLocation {
          companyLocation {
            name
          }
        }
        applicantsCount
      }
      totalCount
    }
  }
`;

export const useGetVacancies = (filters: IVacanciesFilter) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'createdAt', sortBy: -1 },
  ]);
  const { company } = useGetCurrentCompany();
  const pageSize = 12;
  const { data, loading } = useQuery(GET_VACANCIES, {
    variables: {
      workspaceCompanyId: company._id,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
      filters,
    },
    fetchPolicy: 'network-only',
  });

  const { collection = [], totalCount = 0 } = data?.getVacancies || {};

  return {
    loading,
    vacancies: collection,
    paginationConfig: {
      pageSize,
      total: totalCount,
      current: currentPage,
      onChange: (page: number) => setCurrentPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      const sortArray = [];

      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        sortArray.push({ field: 'name', sortBy });
      }

      setNameSort(sortArray);
    },
  };
};
